import { useHistory } from "react-router-dom";
import QRCode from "qrcode.react";
import { WEB_BASE_URL, API_BASE_URL } from "Constants";
import {
  Card,
  BRAND,
  BRAND_SOFT,
  BORDER,
  MUTED,
  TEXT,
  PictX,
  GhostButton,
  COUPON_CATEGORIES,
} from "../../Pages/Sponsor/adminShared";

const categoryMeta = (value) =>
  COUPON_CATEGORIES.find((c) => c.value === value) || COUPON_CATEGORIES.find((c) => c.value === "shop");

const formatExpiry = (end) => {
  if (!end) return "";
  const d = new Date(end);
  return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
};

const QrBlock = ({ label, value, children }) => (
  <div style={{ flex: 1, minWidth: 150 }}>
    <div style={{ fontSize: 11, fontWeight: 800, color: MUTED, letterSpacing: "0.08em", marginBottom: 8 }}>
      {label}
    </div>
    <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
      <div style={{ padding: 8, background: "#fff", border: `1px solid ${BORDER}`, borderRadius: 12 }}>
        <QRCode value={value} size={56} />
      </div>
      {children && <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>{children}</div>}
    </div>
  </div>
);

const CouponsTable = (props) => {
  const history = useHistory();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      {props.coupons.map((coupon) => {
        const cat = categoryMeta(coupon.category);
        return (
          <Card key={coupon.id} style={{ padding: 22 }}>
            <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
              {/* Left — identity */}
              <div style={{ display: "flex", gap: 14, flex: 1, minWidth: 240 }}>
                <img
                  src={coupon.image}
                  alt={coupon.title}
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 16,
                    objectFit: "cover",
                    border: `1px solid ${BORDER}`,
                    flexShrink: 0,
                  }}
                />
                <div style={{ minWidth: 0 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 5,
                        padding: "3px 10px",
                        borderRadius: 999,
                        background: BRAND_SOFT,
                        color: BRAND,
                        fontSize: 11,
                        fontWeight: 800,
                      }}
                    >
                      <PictX name={cat.icon} size={13} stroke={BRAND} strokeWidth={1.8} />
                      {cat.label}
                    </span>
                  </div>
                  <div style={{ fontSize: 17, fontWeight: 800, color: TEXT }}>{coupon.title}</div>
                  <div style={{ fontSize: 13, color: MUTED, lineHeight: 1.6, marginTop: 4 }}>
                    {coupon.description}
                  </div>
                  <div style={{ display: "flex", gap: 14, marginTop: 10, fontSize: 12, color: MUTED }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                      <PictX name="clock" size={14} stroke={MUTED} strokeWidth={1.6} />
                      有効期限 {formatExpiry(coupon.period_end)}
                    </span>
                    <span>残り {coupon.stock} 個</span>
                  </div>
                </div>
              </div>

              {/* Right — actions */}
              <div style={{ flexShrink: 0 }}>
                <GhostButton
                  icon="sliders"
                  style={{ padding: "9px 16px", fontSize: 13 }}
                  onClick={() => history.push("/sponsor/hubs/" + coupon.hub_id + "/coupons/" + coupon.id + "/edit")}
                >
                  編集
                </GhostButton>
              </div>
            </div>

            {/* QR section */}
            <div
              style={{
                display: "flex",
                gap: 24,
                flexWrap: "wrap",
                marginTop: 20,
                paddingTop: 18,
                borderTop: `1px solid ${BORDER}`,
              }}
            >
              {coupon.published ? (
                <QrBlock label="クーポンページQRコード" value={WEB_BASE_URL + "/c/" + coupon.id}>
                  <a
                    href={WEB_BASE_URL + "/c/" + coupon.id}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={qrActionStyle}
                  >
                    クーポンページを開く
                  </a>
                </QrBlock>
              ) : (
                <div style={{ flex: 1, minWidth: 150 }}>
                  <div style={{ fontSize: 11, fontWeight: 800, color: MUTED, letterSpacing: "0.08em", marginBottom: 8 }}>
                    クーポンページQRコード
                  </div>
                  <div style={{ fontSize: 12, color: MUTED, lineHeight: 1.6 }}>
                    クーポンと加盟店が公開されると、クーポンページへの QR コードが表示されます。
                  </div>
                </div>
              )}
              <QrBlock
                label="店頭QRコード"
                value={WEB_BASE_URL + `/public/coupons/${coupon.id}?qr=${coupon.qr_code}`}
              >
                <button
                  onClick={() => props.handleStampQRcodePrintClick(coupon.hub_id, coupon.id)}
                  style={qrActionStyle}
                >
                  ネットプリントで印刷
                </button>
                <button
                  onClick={() => window.open(API_BASE_URL + `/coupons/${coupon.id}/qrcode/${coupon.qr_code}.pdf`)}
                  style={qrActionStyle}
                >
                  ダウンロード
                </button>
              </QrBlock>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

const qrActionStyle = {
  background: "transparent",
  border: 0,
  padding: 0,
  cursor: "pointer",
  color: BRAND,
  fontSize: 13,
  fontWeight: 700,
  textAlign: "left",
  borderBottom: `1px solid ${BRAND}`,
  alignSelf: "flex-start",
};

export default CouponsTable;
